import { helpers } from "@vuelidate/validators";

export const HTTP_URL_PREFIX = "https://";

export const HTTP_URL_ERROR_MESSAGE = "URL format is not valid. Please include http:// or https:// in the URL.";

const HTTP_URL_REGEX = /^https?:\/\/(?:[a-z0-9-]+\.)+[a-z]{2,}(?::\d+)?(?:[/?#][^\s]*)?$/i;

const BARE_PREFIX_REGEX = /^https?:\/\/$/i;

/**
 * Whether `value` holds nothing but whitespace or a bare `http://` / `https://` prefix
 */
export const isBlankUrl = (value: string | null | undefined): boolean => {
  const trimmed = (value ?? "").trim();
  return !trimmed || BARE_PREFIX_REGEX.test(trimmed);
};

/**
 * Value to persist for a URL field: the trimmed URL as entered, or `null` when it is blank.
 */
export const toStoredUrl = (value: string | null | undefined): string | null =>
  isBlankUrl(value) ? null : (value ?? "").trim();

/**
 * Vuelidate rule: blank values pass (pair with `required` when the field is mandatory); anything
 * else must be an absolute http(s) URL.
 */
export const httpUrl = helpers.withMessage(HTTP_URL_ERROR_MESSAGE, (value: string | null | undefined) =>
  isBlankUrl(value) ? true : HTTP_URL_REGEX.test((value ?? "").trim()),
);
